<template>
  <div>
    <el-carousel height="30vw" :arrow="arrow">
      <el-carousel-item v-for="(item, index) in data" :key="index" :arrow="item.imageUrl.length > 1 ? 'hover' : 'never'">
        <img v-for="(list, one) in item.imageUrl" :key="one" style="width: 100%; max-height: 30vw;" :src="list.url" alt="轮播图" @click="swiperEvent(item, list.url)"/>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: 'Swiper',
  props: ['data'],
  data () {
    return {
      arrow: 'never'
    }
  },
  created () {
    if (this.data && this.data.length > 1) {
      this.arrow = 'hover'
    }
  },
  methods: {
    swiperEvent (item, url) {
      // 埋点开始
      philips.analytics.trackConversion ({
        name: "interaction",
        description: "link:banner:" + url
      })
      // 埋点结束
      let path = item.path
      if (path.urlType == 'product') {
        this.$router.push(`/product-detail?id=${path.product.id}`)
        // window.open(`/#/product-detail?id=${path.product.id}`, '_blank')
      } else if (path.urlType == 'webUrl') {
        window.location.href = path.webUrl
      } else if (path.urlType == 'ownUrl') {
        window.location.href = path.ownUrl
      } else if (path.urlType == 'page') {
        if (path.page.id == '111') {
          this.$router.push(`/index`)
        } else {
          this.$router.push(`/decorate?id=${path.page.id}`)
        }
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Swiper.vue